jQuery(document).ready(function() {  
    var lastScrollTop = 0, delta = 15;
    jQuery(window).scroll(function(event){
        var st = jQuery(this).scrollTop();       
         if(Math.abs(lastScrollTop - st) <= delta)
          return;
            if ((st > lastScrollTop) && (lastScrollTop>0)) {
            // downscroll code
              jQuery(".hp-header-main").css("top","-172px");              
            } else {
              // upscroll code
              jQuery(".hp-header-main").css("top","0px");              
          }
    lastScrollTop = st;
    });
     jQuery(window).scroll(function(){
        if (jQuery(window).scrollTop() > 1) {
            jQuery('.hp-header-main').addClass('hp-header-main-white');   
        }
        else {
           jQuery('.hp-header-main').removeClass('hp-header-main-white');
       }
   }); 

  $('a[href*="blvd.me/helloprfct/gift-cards"], a[href*="blvd.app/@helloprfct/login"]')
  .attr({
    target: '_blank',
    rel: 'noopener noreferrer'
  });
$('a[href*="ekmqy.myaestheticrecord.com/online-booking"]')
    .attr({
      'target': '_blank',
      'rel': 'noopener noreferrer'
});
$('a[href*="https://ekmqy.myaestheticrecord.com/login"]')
    .attr({
      'target': '_blank',
      'rel': 'noopener noreferrer'
});

   
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ajax-add-to-cart").forEach(function(form) {
    
    form.addEventListener("submit", function(e) {
      e.preventDefault();

      let formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          "Accept": "application/json"
        }
      })
      .then(response => response.json())
      .then(data => {
        
        // Optional: Update Cart Count
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = cart.item_count;
          });
        });

        // Optional Success Message
        form.querySelector("button").innerText = "Added ✓";
        setTimeout(() => {
          form.querySelector("button").innerText = "Add to Cart";
        }, 2000);

      })
      .catch(error => {
        console.error("Error:", error);
      });

    });

  });
});

// Home Page Video Toggle Function: Play/Pause button.
function toggleVideo() {    
    var video = document.getElementById('hpHomeBannerVideo');    
    var btn = document.querySelector('button[aria-controls="hpHomeBannerVideo"]');
    
    if (!video || !btn) return; 

    if (video.paused) {        
        video.play();
        btn.innerHTML = "Pause";
        btn.setAttribute('aria-label', 'Pause Video');
    } else {
        video.pause();
        btn.innerHTML = "Play";
        btn.setAttribute('aria-label', 'Play Video');
    }
}

// Home Page Video Load Event: Video auto-play after page loaded.
window.addEventListener('load', function() {
    var video = document.getElementById('hpHomeBannerVideo');
    var btn = document.querySelector('button[aria-controls="hpHomeBannerVideo"]');

    if (video) {
        var playPromise = video.play();

        if (playPromise !== undefined) {
            playPromise.then(function() {
                console.log("Video playing automatically after page load");
                if (btn) {
                    btn.innerHTML = "Pause";
                    btn.setAttribute('aria-label', 'Pause Video');
                }
            }).catch(function(error) {
                console.log("Autoplay was prevented. User needs to click play.");
                if (btn) {
                    btn.innerHTML = "Play";
                    btn.setAttribute('aria-label', 'Play Video');
                }
            });
        }
    }
});
